import { render, staticRenderFns } from "./LoginHelp.vue?vue&type=template&id=770bb1d0&scoped=true&"
import script from "./LoginHelp.vue?vue&type=script&lang=js&"
export * from "./LoginHelp.vue?vue&type=script&lang=js&"
import style0 from "./LoginHelp.vue?vue&type=style&index=0&id=770bb1d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770bb1d0",
  null
  
)

export default component.exports